import { Link } from "react-router-dom";
import { TableCell, Typography } from "@mui/material";

import useRouteMatchURL from "../../../../../Components/hooks/useRouteMatchURL";
import { roundToPrecision } from "../../../../../utils/numbers";
import ClusterType from "../../../Clusters/Table/ClusterType";
import { type DashboardCluster } from "../../../types";

interface Fsk8sClusterTableRowProps {
  row: DashboardCluster;
}

const Fsk8sClusterTableRow = ({ row }: Fsk8sClusterTableRowProps) => {
  const routeMatchUrl = useRouteMatchURL();

  return (
    <>
      <TableCell>
        <Typography
          component={Link}
          to={`${routeMatchUrl}/clusters/${row.doitCluster?.id}`}
          color="inherit"
          variant="body2"
          title="Click to enable features"
          sx={{ textDecorationColor: "inherit", cursor: "pointer" }}
        >
          {row.name}
        </Typography>
      </TableCell>
      <TableCell>
        <ClusterType type={row.cloud} />
      </TableCell>
      <TableCell align="right">${roundToPrecision(row.cost, 2)}</TableCell>
      {/* TODO: add potential savings */}
      {/* <TableCell align="right">$2.50</TableCell> */}
      <TableCell align="right">{row.workloads}</TableCell>
      <TableCell align="right">{roundToPrecision(row.cpuUtilization, 2)}</TableCell>
      <TableCell align="right">{roundToPrecision(row.memUtilization, 2)} Mi</TableCell>
    </>
  );
};

export default Fsk8sClusterTableRow;
